// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "DAI",
    token: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE",
    variableDebtTokenAddress: "0x8619d80FB0141ba7F184CbF22fd724116D9f7ffC",
  },
  {
    symbol: "LINK",
    token: "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530",
    variableDebtTokenAddress: "0x953A573793604aF8d41F306FEb8274190dB4aE0e",
  },
  {
    symbol: "USDC.e",
    token: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x625E7708f30cA75bfd92586e17077590C60eb4cD",
    variableDebtTokenAddress: "0xFCCf3cAbbe80101232d343252614b6A3eE81C989",
  },
  {
    symbol: "WBTC",
    token: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x078f358208685046a11C85e8ad32895DED33A249",
    variableDebtTokenAddress: "0x92b42c66840C7AD907b4BF74879FF3eF7c529473",
  },
  {
    symbol: "WETH",
    token: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8",
    variableDebtTokenAddress: "0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351",
  },
  {
    symbol: "USD₮0",
    token: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x6ab707Aca953eDAeFBc4fD23bA73294241490620",
    variableDebtTokenAddress: "0xfb00AC187a8Eb5AFAE4eACE434F493Eb62672df7",
  },
  {
    symbol: "AAVE",
    token: "0xba5DdD1f9d7F570dc94a51479a000E3BCE967196",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xf329e36C7bF6E5E86ce2150875a84Ce77f477375",
    variableDebtTokenAddress: "0xE80761Ea617F66F96274eA5e8c37f03960ecC679",
  },
  {
    symbol: "EURS",
    token: "0xD22a58f79e9481D1a88e00c343885A588b34b68B",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97",
    variableDebtTokenAddress: "0x4a1c3aD6Ed28a636ee1751C69071f6be75DEb8B8",
  },
  {
    symbol: "wstETH",
    token: "0x5979D7b546E38E414F7E9822514be443A4800529",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf",
    variableDebtTokenAddress: "0x77CA01483f379E58174739308945f044e1a764dc",
  },
  {
    symbol: "MAI",
    token: "0x3F56e0c36d275367b8C502090EDF38289b3dEa0d",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA",
    variableDebtTokenAddress: "0x34e2eD44EF7466D5f9E0b782B5c08b57475e7907",
  },
  {
    symbol: "rETH",
    token: "0xEC70Dcb4A1EFa46b8F2D97C310C9c4790ba5ffA8",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x8Eb270e296023E9D92081fdF967dDd7878724424",
    variableDebtTokenAddress: "0xCE186F6Cccb0c955445bb9d10C59caE488Fea559",
  },
  {
    symbol: "LUSD",
    token: "0x93b346b6BC2548dA6A1E7d98E9a421B42541425b",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x8ffDf2DE812095b1D19CB146E4c004587C0A0692",
    variableDebtTokenAddress: "0xA8669021776Bc142DfcA87c21b4A52595bCbB40a",
  },
  {
    symbol: "USDC",
    token: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x724dc807b04555b71ed48a6896b6F41593b8C637",
    variableDebtTokenAddress: "0xf611aEb5013fD2c0511c9CD55c7dc5C1140741A6",
  },
  {
    symbol: "FRAX",
    token: "0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x38d693cE1dF5AaDF7bC62595A37D667aD57922e5",
    variableDebtTokenAddress: "0x5D557B07776D12967914379C71a1310e917C7555",
  },
  {
    symbol: "ARB",
    token: "0x912CE59144191C1204E64559FE8253a0e49E6548",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x6533afac2E7BCCB20dca161449A13A32D391fb00",
    variableDebtTokenAddress: "0x44705f578135cC5d703b4c9c122528C73Eb87145",
  },
  {
    symbol: "weETH",
    token: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x8437d7C167dFB82ED4Cb79CD44B7a32A1dd95c77",
    variableDebtTokenAddress: "0x3ca5FA07689F266e907439aFd1fBB59c44fe12f6",
  },
  {
    symbol: "GHO",
    token: "0x7dfF72693f6A4149b17e7C6314655f6A9F7c8B33",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xeBe517846d0F36eCEd99C735cbF6131e1fEB775D",
    variableDebtTokenAddress: "0x18248226C16BF76c032817854E7C83a2113B4f06",
  },
  {
    symbol: "ezETH",
    token: "0x2416092f143378750bb29b79eD961ab195CcEea5",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xEA1132120ddcDDA2F119e99Fa7A27a0d036F7Ac9",
    variableDebtTokenAddress: "0x1fFD28689DA7d0148ff0fCB669e9f9f0Fc13a219",
  },
  {
    symbol: "rsETH",
    token: "0x4186BFC76E2E237523CBC30FD220FE055156b41F",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x6b030Ff3FB9956B1B69f475B77aE0d3Cf2CC5aFa",
    variableDebtTokenAddress: "0x80cA0d8C38d2e2BcbaB66aA1648Bd1C7160500FE",
  },
  {
    symbol: "tBTC",
    token: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x62fC96b27a510cF4977B59FF952Dc32378Cc221d",
    variableDebtTokenAddress: "0xB5b46F918C2923fC7f26DB76e8a6A6e9C4347Cf9",
  },
] as const
